export function sortNumsDescCompareFn(a, b) {
    let clonedA = a;
    let clonedB = b;
    if (clonedA == null || typeof clonedA === 'undefined') clonedA = -9999999;
    if (clonedB == null || typeof clonedB === 'undefined') clonedB = -9999999;
    return clonedB - clonedA;
}

export function sortNumsAscCompareFn(a, b) {
    let clonedA = a;
    let clonedB = b;
    if (clonedA == null || typeof clonedA === 'undefined' || clonedA === 0) clonedA = 9999999;
    if (clonedB == null || typeof clonedB === 'undefined' || clonedB === 0) clonedB = 9999999;

    return clonedA - clonedB;
}

export function sortAlphaDescCompareFn(a, b) {
    return (`${b}`).localeCompare(a);
}

export function sortAlphaAscCompareFn(a, b) {
    return (`${a}`).localeCompare(b);
}
export function sortEgyuttDijakFn(direction = 'asc') {
    return (a, b) => {
        const aHas = (a.kgfb?.egyuttkotes?.yearly_fee && a.casco?.egyuttkotes?.yearly_fee)
            || (a.kgfb?.yearly_fee && a.casco?.yearly_fee);

        const bHas = (b.kgfb?.egyuttkotes?.yearly_fee && b.casco?.egyuttkotes?.yearly_fee)
            || (b.kgfb?.yearly_fee && b.casco?.yearly_fee);

        if (!aHas && !bHas) return 0;
        if (!aHas) return 1;
        if (!bHas) return -1;

        const aTotal = (Number(a.kgfb?.egyuttkotes?.yearly_fee || a.kgfb?.yearly_fee)
            + Number(a.casco?.egyuttkotes?.yearly_fee || a.casco?.yearly_fee));

        const bTotal = (Number(b.kgfb?.egyuttkotes?.yearly_fee || b.kgfb?.yearly_fee)
            + Number(b.casco?.egyuttkotes?.yearly_fee || b.casco?.yearly_fee));

        return direction === 'asc' ? aTotal - bTotal : bTotal - aTotal;
    };
}
